import * as React from 'react'
import { ResourcesRecordShape } from '../../api/api_data_types'
import EntryItem from './EntryItem'
import InlineEditForm from './InlineEditForm'
import ExportToNavButton from './ExportToNavButton'
import EntryActions from './EntryActions'
import {
  new_resources_adjustment_path,
  edit_resources_record_path,
  new_resources_record_path,
  export_to_nav_resources_record_path,
} from '../../routes'
import { EditModeContext } from './EditModeContext'

type RecordItemProps = {
  record: ResourcesRecordShape
}

export default function RecordItem({ record }: RecordItemProps) {
  const editModeContext = React.useContext(EditModeContext)
  const isExported = record.exported === true
  const fromApprovedWeek = record.from_approved_week === true
  const canExport = record.can_export_to_nav === true
  const canInlineEdit = !isExported && !fromApprovedWeek && record.times.length === 1
  const isEditMode = editModeContext?.isEditMode === true

  if (isEditMode && canInlineEdit) {
    return <InlineEditForm record={record} onCancel={() => {}} onSave={() => {}} />
  }

  return (
    <EntryItem
      jobTitle={`${record.jobnumber.order_number_title}. ${record.jobnumber.customer_title}`}
      times={record.times}
      footer={
        <>
          {isExported && (
            <EntryActions
              actions={[
                <a
                  className="btn btn-outline-secondary"
                  href={new_resources_adjustment_path({ master_id: record.id })}
                >
                  Tilføj korrektion
                </a>,
              ]}
            />
          )}
          {!isExported && !fromApprovedWeek && (
            <EntryActions
              actions={[
                <a className="btn btn-outline-secondary" href={edit_resources_record_path(record.id)}>
                  Ændre
                </a>,
                <a
                  className="btn btn-outline-secondary ml-2 mr-2"
                  href={new_resources_record_path({ duplicate: record.id })}
                >
                  Kopier
                </a>,
                canExport ? (
                  <ExportToNavButton
                    className="mt-md-0 mt-2"
                    href={export_to_nav_resources_record_path(record.id)}
                  />
                ) : null,
              ].filter(Boolean) as React.ReactNode[]}
            />
          )}
        </>
      }
    />
  )
}

